import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { reduxForm, Field } from 'redux-form';
import translate from '../TranslateHOC';
import { renderDigitField, autoTabPin } from '../../form_helpers';
import { PIN_SIZE, PIN_YOUR_ID, PATH_PARENT } from '../../constants';
import { getPin, validatePin } from '../../parent_control_helper';
import { connect } from 'react-redux';
import { verifyPin, resetVerifyPin } from '../../actions';
import ErrorAlert from '../mys4c/alerts/ErrorAlert';
import { Link } from 'react-router-dom';
import { Button as ButtonV2 } from '../../v2/components/button/Button';

const submit = (values, dispatch, props) => {
  let pin = getPin(values, PIN_YOUR_ID);
  if (pin) {
    props.verifyPin(pin);
  }
};

const validate = (values, props) => {
  let errors = {};
  let pinErrors = validatePin(values, props.strings, PIN_YOUR_ID);
  errors = Object.assign(errors, pinErrors);
  return errors;
};

class EnterPinForm extends Component {
  constructor() {
    super();
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    this.props.resetVerifyPin();
    this.props.handleCancel();
  }

  componentDidMount = () => {
    autoTabPin(this.refs.pinHolder);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.pinCheckSuccess) {
      nextProps.resetVerifyPin();
      nextProps.handleConfirm();
    }
  };

  componentWillUnmount = () => {
    this.props.resetVerifyPin();
  };

  render() {
    const {
      handleSubmit,
      submitting,
      pristine,
      strings,
      pinCheckSuccess,
      pinCheckSuccessError,
    } = this.props;

    return (
      <div className="dialog--verify-age">
        <div className="dialog__title">{strings.contentWarningTitle}</div>
        <div className="dialog__instruction">
          {strings.contentWarningChallengePin}
        </div>
        <form
          className="dialog__form"
          onSubmit={handleSubmit(submit)}
          noValidate
          autoComplete="off"
        >
          <div className="form__pin-holder" ref="pinHolder">
            <div className="form__label">{strings.enterPin}</div>
            {[...Array(PIN_SIZE)].map((x, i) => (
              <Field
                name={PIN_YOUR_ID + (i + 1)}
                type="password"
                component={renderDigitField}
                label={strings['digit' + (i + 1)]}
                key={i}
                autoFocus={i === 0 ? true : false}
              />
            ))}
          </div>
          {pinCheckSuccess === false && (
            <ErrorAlert errorMessage={strings.incorrectPin} />
          )}
          {pinCheckSuccessError && (
            <ErrorAlert errorMessage={pinCheckSuccessError} />
          )}
          <Link to={PATH_PARENT} className="form__forgot">
            {strings.forgottenPin}
          </Link>
          <ButtonContainer>
            <button
              className="dialog__btn dialog__btn--cancel"
              type="button"
              onClick={this.handleCancel}
            >
              {strings.cancel}
            </button>
            <ButtonV2
              onClick={handleSubmit(submit)}
              label={strings.ok}
              size="small"
              disabled={pristine || submitting}
            />
          </ButtonContainer>
        </form>
      </div>
    );
  }
}

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 2em;
  align-items: center;
  justify-content: right;
  button {
    margin-right: 20px;
  }
`;

EnterPinForm = reduxForm({
  form: 'enterPin',
  validate,
})(EnterPinForm);

EnterPinForm = connect(
  (state) => ({
    pinCheckSuccess: state.pinCheckSuccess.success,
    pinCheckSuccessError: state.pinCheckSuccess.error,
  }),
  { verifyPin, resetVerifyPin }
)(EnterPinForm);

export default translate(EnterPinForm);
